export default __webpack_public_path__ + "static/media/loader.ce1dbe91.gif";